<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-group mb-20" [class.has-error]="isEmptyLabel">
            <label class="col-xs-12">
                {{ "control_text" | translate }}
            </label>
            <div class="col-xs-12">
                <input class="form-control" [formControl]="label" />
                <span class="help-block small" *ngIf="isEmptyLabel">
                    {{ "control_errors_required" | translate }}
                </span>
            </div>
        </div>

        <ng-content select=".after-text"></ng-content>

        <div class="form-row mb-20">
            <div class="form-group">
                <label class="col-xs-12">
                    {{ "control_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" [formControl]="styleType">
                        <option [ngValue]="EButtonStyleType.primary">
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option [ngValue]="EButtonStyleType.secondary">
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [ngValue]="EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group d-flex">
                        <sp-radio-group
                            [selected]="size.value"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="styleType.value === EButtonStyleType.custom">
            <div class="form-row mb-20">
                <sp-custom-button
                    showHoverSettings
                    [isIndependentCorners]="isIndependentCorners.value"
                    [radiusSettings]="advancedRadius.value"
                    [advancedBorderSettings]="advancedBorderSettings.value"
                    [isAdvancedRadius]="true"
                    [parentBase]="buttonBase.value"
                    [parentHover]="buttonHover.value"
                    [colorsPreset]="selectedThemeColors()"
                    [buttonMode]="ButtonMode.light"
                    (valueChangeEvent)="customButtonChangeHandler($event)"
                ></sp-custom-button>
            </div>
        </ng-container>
        <div class="form-row">
            <div *ngIf="!isHorizontalForm" class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_width" | translate }}
                </label>
                <div
                    [class.col-xs-7]="widthType.value === EButtonWidthType.fixed"
                    [class.col-xs-12]="widthType.value !== EButtonWidthType.fixed"
                >
                    <select class="form-control" [formControl]="widthType">
                        <option [ngValue]="EButtonWidthType.auto">
                            {{ "control_appearance_auto" | translate }}
                        </option>
                        <option [ngValue]="EButtonWidthType.full">
                            {{ "control_appearance_full" | translate }}
                        </option>
                        <option [ngValue]="EButtonWidthType.fixed">
                            {{ "control_appearance_fixed" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-5" *ngIf="widthType.value === EButtonWidthType.fixed">
                    <sp-input-num
                        suffixText="px"
                        [min]="CSS_RESTRICTIONS.MIN_WIDTH_BUTTON_VALUE"
                        [value]="widthValue.value"
                        (valueChange)="setWidthValue($event)"
                    ></sp-input-num>
                </div>
            </div>

            <div *ngIf="isHorizontalForm" class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_width" | translate }}
                </label>
                <div
                    [class.col-xs-7]="horizontalFormWidthType.value === EButtonWidthType.fixed"
                    [class.col-xs-12]="horizontalFormWidthType.value !== EButtonWidthType.fixed"
                >
                    <select class="form-control" [formControl]="horizontalFormWidthType">
                        <option [ngValue]="EButtonWidthType.auto">
                            {{ "control_appearance_auto" | translate }}
                        </option>
                        <option [ngValue]="EButtonWidthType.full">
                            {{ "control_appearance_full" | translate }}
                        </option>
                        <option [ngValue]="EButtonWidthType.fixed">
                            {{ "control_appearance_fixed" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-5" *ngIf="horizontalFormWidthType.value === EButtonWidthType.fixed">
                    <sp-input-num
                        suffixText="px"
                        [min]="CSS_RESTRICTIONS.MIN_WIDTH_BUTTON_VALUE"
                        [value]="widthValue.value"
                        (valueChange)="setWidthValue($event)"
                    ></sp-input-num>
                </div>
            </div>

            <div>
                <sp-button-icon [buttonIcon]="buttonIcon.value" (valueChangeEvent)="buttonIconChangeHandler($event)">
                </sp-button-icon>
            </div>

            <div class="mb-15">
                <sp-button-additional-effects-settings
                    [additionalEffects]="additionalEffects.value"
                    (valueChangeEvent)="additionalEffectsChangeHandler($event)"
                >
                </sp-button-additional-effects-settings>
            </div>

            <div class="form-group" [class.mb-20]="!isShadow.value" [class.mb-10]="isShadow.value">
                <label class="col-xs-9 control-label">
                    {{ "control_shadow" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="isShadow.value" (toggleActiveEvent)="setShadow($event)"></sp-switch>
                </div>
            </div>

            <ng-container *ngIf="isShadow.value">
                <sp-shadow-settings
                    [shadowSettings]="shadowSettingsValue"
                    (valueChangeEvent)="setShadowSettings($event)"
                ></sp-shadow-settings>
            </ng-container>
        </div>
    </div>
</div>
